export default "__VITE_ASSET__CX2Fz_66__"